
import { computed, defineComponent, PropType } from "vue";
import { consts, ContractStatus, IContract } from "@/services/Models";
import { fromUnixTime, yyyyMMdd } from "@/lib/shared";

const greenIcon = "/icons/green.svg";
const yellowIcon = "/icons/yellow.svg";
const redIcon = "/icons/red.svg";

const trialIcon = "/icons/trial.png";
const agreeIcon = "/icons/agree.png";

export default defineComponent({
  name: "AdminContractItem",
  props: {
    item: { type: Object as PropType<IContract> },
    isHeader: { type: Boolean },
  },
  setup(props, context) {
    const isDisabled = computed(
      () => props.item?.status == ContractStatus.Disabled
    );
    const isExpire = (expireDate: Date) => {
      const now = new Date();
      expireDate.setHours(0, 0, 0, 0);
      now.setHours(0, 0, 0, 0);
      return expireDate < now;
    };
    // 契約期日まで1か月以内かどうか
    const isNearExpired = computed(() => {
      if (!props.item) return false;
      const oneMonthAgo = fromUnixTime(props.item.expire);
      oneMonthAgo.setDate(oneMonthAgo.getDate() - consts.expireOneMonth - 1);
      return isExpire(oneMonthAgo);
    });
    // 契約期日を過ぎているかどうか
    const isExpired = computed(() => {
      if (!props.item) return false;
      const expireDate = fromUnixTime(props.item.expire);
      return isExpire(expireDate);
    });

    const isPermanentFalse = false;

    const statusIcon = computed(() => {
      // 停止中は停止アイコン
      if (isDisabled.value) {
        return redIcon;
      }
      // 停止じゃない場合はいちゃもんついてなければgreen
      const isWarning = isExpired.value || isNearExpired.value;
      return isWarning ? yellowIcon : greenIcon;
    });
    //TODO:アイコンのふり分け
    const typeIcon = computed(() => {
      if (!props.item) return false;

      // 本契約アイコン
      if (props.item.type == 1) {
        return agreeIcon;
      }
      // トライアルアイコン
      return trialIcon;
    });

    return {
      fromUnixTime,
      yyyyMMdd,
      isDisabled,
      isExpired,
      isNearExpired,
      statusIcon,
      typeIcon,
      context,
      isPermanentFalse,
    };
  },
});
